import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";
import { OutputFormat } from "../download";

export const triggerFileDownload = {
  name: "triggerFileDownload" as const,
  input: z.object({
    reportType: z.string(),
    // Opaque per-report params; validated server-side against the report's
    // own schema before the job is created.
    parameters: z.unknown(),
    format: createEnum(OutputFormat).optional(),
    // When true, the finished file is emailed (a presigned link) to the
    // authenticated user who triggered it; otherwise it only surfaces on the
    // downloads page. The recipient is always the requesting user — resolved
    // server-side, never a client-supplied address — so an export can't be
    // delivered to an arbitrary inbox.
    sendEmail: z.boolean().optional(),
  }),
  output: z.object({ downloadId: z.string() }),
};
